<template>
  <v-container fluid class="px-8 py-0">
    <template v-slot:after-heading> </template>
    <v-row class="d-flex justify-space-between mx-1 mb-0">


    </v-row>

    <!-- <v-divider class="mt-3" /> -->

    <v-simple-table fixed-header class="pa-3">
      <template v-slot:default>
        <thead>
          <tr>
            <th>ID</th>
            <th>文件名称</th>

            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          
          <tr >
            <td class="font-weight-light  text-left" style="font-size:11px">
              1
            </td>
            <td class="text-left">
              面积公示表
            </td>
           <td>
              <v-btn color="warning" icon @click="goToArea()" >
                <v-icon left>{{ icons.list.icon }}</v-icon>
              </v-btn>
            </td>
          </tr>
          <tr >
            <td class="font-weight-light  text-left" style="font-size:11px">
              2
            </td>
            <td class="text-left">
              搬迁公告文件
            </td>
           <td>
              <v-btn color="warning" icon @click="goToNotice()" >
                <v-icon left>{{ icons.list.icon }}</v-icon>
              </v-btn>
            </td>
          </tr>
          <tr >
            <td class="font-weight-light  text-left" style="font-size:11px">
              3
            </td>
            <td class="text-left">
              城中村相关文件
            </td>
           <td>
              <v-btn color="warning" icon @click="goToVillagesInCities()" >
                <v-icon left>{{ icons.list.icon }}</v-icon>
              </v-btn>
            </td>
          </tr>
          <tr >
            <td class="font-weight-light  text-left" style="font-size:11px">
              4
            </td>
            <td class="text-left">
              政策文件
            </td>
           <td>
              <v-btn color="warning" icon @click="goToPolicy()" >
                <v-icon left>{{ icons.list.icon }}</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>


  </v-container>
</template>

<script>
const batchCodeOptions = [
  { key: '01', display_name: "01" },
  { key: '02', display_name: "02" },
  { key: '03', display_name: "03" }
];

import {
  fetchContracts,
} from "@/api/contracts";
import {
  fetchGarden,
  fetchBuilding,
  fetchUnit
} from "@/api/customers";

import { fetchProjectsList } from "@/api/projects";
import { fetchVillagesList } from "@/api/villages";
export default {
  name: "Contracts",

  data: () => ({
    snackbar: false,
    text: "",
    timeout: 3000,
    panel: [0, 1],
    printer: {
      single: {
        color: "blue",
        icon: "mdi-printer"
      },
      batch: {
        color: "secondary",
        icon: "mdi-printer"
      },
      pay: {
        color: "green",
        icon: "mdi-cash-usd"
      }
    },
    exportItems: [],
    items: [],
    listQuery: {
      page: 1,
      limit: 12,
      customer_code: undefined,
      customer_name: undefined,
      sort: "+id",
      orderby: undefined,
      village_id: undefined,
    },
    villagesOptions: [],
    projectsOptions: [],
    gardenOptions: [],
    buildingOptions: [],
    unitOptions: [],
    search: "",
    awaitingSearch: false,
    circle: true,
    disabled: false,
    length: 10,
    nextIcon: "mdi-chevron-right",
    prevIcon: "mdi-chevron-left",
    totalVisible: 10,
    total_pages: 0,


    greenColor: "rgb(81, 185, 116)",
    warningColor: "rgb(241, 211, 171)",
    batchCodeOptions,
    icons: {
      single: {
        color: "blue",
        icon: "mdi-printer"
      },
      batch: {
        color: "secondary",
        icon: "mdi-printer"
      },
      pay: {
        color: "green",
        icon: "mdi-cash-100"
      },
      list: {
        color: "",
        icon: "mdi-format-list-bulleted"
      },
      delete: {
        color: "green",
        icon: "mdi-delete"
      },
      heart: {
        color: "green",
        icon: "mdi-heart-box"
      },
      action: {
        color: "info",
        icon: "mdi-account-details"
      },
      checkin: {
        color: "info",
        icon: "mdi-checkbox-marked-circle"
      },
      chy: {
        color: "info",
        icon: "mdi-currency-jpy"
      },
      print: {
        color: "info",
        icon: "mdi-printer"
      },
      lock: {
        color: "info",
        icon: "mdi-lock"
      },
      unlock: {
        color: "info",
        icon: "mdi-lock-open"
      }
    }
  }),

  computed: {
    isAdminRole() {
      if (this.$store.getters.roles.includes("administrator")) {
        return true;
      } else {
        return false;
      }
    }
  },

  created() {

  },
  methods: {
    goToArea() {
      // console.log(row.id)
      this.$router.push({
        name: "面积公示表",
      });
    },
    goToNotice() {
      this.$router.push({
          name: "搬迁公告文件",
      });
    },
    goToVillagesInCities() {
      this.$router.push({
          name: "城中村相关文件",
      });
    },
    goToPolicy() {
      this.$router.push({
          name: "政策文件",
      });
    }
  }
};
</script>

<style scoped>
table,
thead,
tr {
  color: #fff;
  font-weight: 400;
}

.background-transparent {
  background-color: transparent !important;
}

tr:hover {
  background-color: #0282b4 !important;
}
</style>
